import { render, staticRenderFns } from "./categ_modal.vue?vue&type=template&id=9ac86f36&scoped=true&"
import script from "./categ_modal.vue?vue&type=script&lang=js&"
export * from "./categ_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac86f36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ac86f36')) {
      api.createRecord('9ac86f36', component.options)
    } else {
      api.reload('9ac86f36', component.options)
    }
    module.hot.accept("./categ_modal.vue?vue&type=template&id=9ac86f36&scoped=true&", function () {
      api.rerender('9ac86f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/category/categ_modal.vue"
export default component.exports